import { render, staticRenderFns } from "./CanalMessengerSinglePage.vue?vue&type=template&id=5efbe814&scoped=true&lang=pug"
import script from "./CanalMessengerSinglePage.vue?vue&type=script&lang=js"
export * from "./CanalMessengerSinglePage.vue?vue&type=script&lang=js"
import style0 from "./CanalMessengerSinglePage.vue?vue&type=style&index=0&id=5efbe814&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efbe814",
  null
  
)

export default component.exports